"use client";
import { useSite } from "@/lib/hooks/site";
import AddPlaceForm from "../Form";
import { useTranslation } from "@/hooks/translationContext";

export default function LastForm() {
  const site = useSite();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-14 container md:mt-16">
      <div className="flex flex-col gap-7 max-w-[795px]">
        <h2 className="text-center font-bold text-2xl md:text-[32px]">
          {t("add-venue-page-seventh-section-title", {
            defaultValue: `${site.domain}’da rakiplerinizin yakaladığı iş fırsatlarını siz de görün!`
          })}
        </h2>

        <h3 className="text-assistant text-sm md:text-base text-center font-bold">
          {t("add-venue-page-seventh-section-description", {
            defaultValue: `Google’da ${site.descriptions[0]?.title} ile ilgili aramalarda
          ${site.domain} en üstlerde yer alıyor ve ziyaretçiler bu sayede
          işletmelerimize ve kampanyalarınıza kolayca erişebiliyor.`
          })}
        </h3>
      </div>

      <div className="flex flex-col max-w-[444px] w-full">
        <div className="flex flex-col gap-2">
          <h2 className="font-bold text-assistant text-2xl text-center md:text-[28px]">
            {t("add-venue-page-seventh-section-form-title", {
              defaultValue: `${site.descriptions[0]?.title} sitesine işletmenizi ekleyin işinizi büyütün!`
            })}
          </h2>

          <h3 className="text-sm md:text-base text-center text-assistant font-bold">
            {t("add-venue-page-seventh-section-form-description", {
              defaultValue: "Binlerce ziyaretçimize işletmenizi gösterin."
            })}
          </h3>
        </div>

        <AddPlaceForm formId="last-form" />
      </div>
    </div>
  );
}
